<template>
  <div class="widget-list">
    <div class="typo-littleblack"><i class="fas fa fa-1x fa-clock-o mr-2"></i>Timezone location: {{this.$store.state.timezoneLocation}}</div>
    <b-table
      class="widget-table"
      :items="reportItems"
      :fields="reportTestFields"
      :state="lastSortedLogbook"
    >
      <template v-slot:cell(cod)="{ item: item }"> 
        <strong class="font-16m">{{item.cod}}</strong>
        <br />
        {{item.evDesc}}
      </template>
      <template v-slot:cell(evEsito)="{ item: item }">
        <div v-if="item.evEsito.includes('exclamation')" :content="$t('report_table.error_auto_in_funct')" v-tippy="{ placement: 'top', arrow: true}" >
          <i class="fa fa-circle" style="color: #00CC00"></i> 
          <i class="fa fa-exclamation pl-1" style="color: red"></i> 
        </div>
        <div v-else>
          <i :class="['fa ' +item.evEsito, 'my-auto']"></i>
        </div>  
      </template>
      <template v-slot:cell(dataEv)="{ item: item }">
        <strong>{{item.dataEv.split("\n")[0]}}</strong>
        <br />
        {{item.dataEv.split("\n")[1]}}
      </template>
      <template v-slot:cell(evDesc)="{ item: item }">
          <DownloadPdfSingleReport :report="getReport(item)" :plant="$store.state.currentPlant"></DownloadPdfSingleReport>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DownloadPdfSingleReport from "./DownloadPdfSingleReport.vue";

export default {
  name: "logbookOverview",
  components:{
    DownloadPdfSingleReport
  },
  data() {
    return {
      reportItems: [],
      reportTestFields: [
        { key: "dataEv", label: this.$t("cards.date_report") },
        { key: "cod", label: this.$t("cards.central_type") },
        { key: "evEsito", label: this.$t("cards.result"), tdClass: "text-center align-middle" },
        { key: "evDesc", label: this.$t("cards.title_report"), tdClass: "align-middle" }
      ]
    };
  },
  mounted() {
    this.lastSortedLogbook();
  },
  computed: {
    currentLogbooks() {
      return this.$store.state.currentLogbooks;
    }
  },
  watch: {
    currentLogbooks() {
      this.lastSortedLogbook();
    }
  },
  methods: {
    lastSortedLogbook() {
      if (this.$store.state.currentLogbooks != null) {
        //filtra i logbook relativi esclusivamente a test funzionali e di autonomia
        var sortedLogbook = this.$store.state.currentLogbooks.filter(function (item) {
          return (
            item.log_type != "assenza_rete" && item.log_type != "rientro_rete" && item.log_type != "vuoto"
          );
        });
        //ordina i logbook per data partendo dalla data più recente
        sortedLogbook.sort(function (a, b) {
          return b.log_timestamp - a.log_timestamp;
        });
        //inserisce i dati negli items della tabella con ultimi test
        let icon_esito = "";
        let formatted_date = "";
        let formatted_logtype = "";
        let last_number_of_test = 10;
        this.reportItems = [];
        if (sortedLogbook.length < last_number_of_test)
          last_number_of_test = sortedLogbook.length;
        for (var i = 0; i < last_number_of_test; i++) {
          if (sortedLogbook[i].log_esito == "pass")
          {
            if (sortedLogbook[i].log_type=='test_funzionale_automatico' && sortedLogbook[i].log_lamps.some((el) => el.error_batt_test_auto=='ON'))
              icon_esito = "fa-exclamation danger";
            else
              icon_esito = "fa-circle success";
          }
          else 
          {
            icon_esito = "fa-circle danger";
          }

          //var dateObj = new Date(sortedLogbook[i].log_timestamp * 1000);
          var dateObj = new Date(sortedLogbook[i].log_date);
          formatted_date =
            dateObj.toLocaleDateString() +
            "\n" +
            dateObj.toLocaleTimeString()
          formatted_logtype = this.$t(
            "report_table." + sortedLogbook[i].log_type
          );
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.reportItems.push({
            dataEv: formatted_date,
            cod: sortedLogbook[i].cu_id,
            type: sortedLogbook[i].log_system,
            evDesc: formatted_logtype,
            evEsito: icon_esito,
            timestamp: sortedLogbook[i].log_timestamp
          });
        }
        console.log("lastSortedLogbook: ", this.reportItems);
      }
    },

    getReport(report)
    {
      return this.$store.state.currentLogbooks.filter(function(item)
          {
            if (item.log_timestamp == report.timestamp && item.cu_id==report.cod) return true;
          })[0];
    },
  }
}
</script>